import React from "react"
import classNames from "classnames"

export interface CaptionProps {
  /**
   * Determines if a caption has a border or not
   */
  border?: "left"
  /**
   * The text content of the caption?
   */
  children: React.ReactNode
  /**
   * Additional classnames for caption
   */
  className?: string
}

/**
 * Muted text intended to describe media (image, video, etc.)
 *
 */
const Caption = ({ children, border, className }: CaptionProps) => {
  const _className = classNames([
    `text-sm leading-snug text-gray-700 mt-2 space-y-2`,
    {
      "border-gray-300 border-0 border-l-4 border-solid px-2":
        border === "left",
    },
    className,
  ])

  return <div className={_className}>{children}</div>
}

export default Caption
